import i18n from "i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { log } from "../utils/logger";

i18n
  // load translation using http -> see /public/locales
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: "en",
    // debug: !process.env.NODE_ENV.includes("prod"),

    // Name spaces - not using "translation" default, so pre-load common instead
    // others loaded as-needed
    ns: ["common"],

    // send not translated keys to endpoint
    saveMissing: true,

    // not needed for react as it escapes by default
    interpolation: {
      escapeValue: false,
    },
  })
  .then((t) => {
    log("-- Internationalization Initialized --");
  })
  .catch((err) => {
    throw new Error(err);
  });

export default i18n;
